﻿import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import theme from "./GenderSelector.module.sass";

const GenderSelector = forwardRef(({ error, ...others }, ref) => (
  <div className={theme.GenderSelector}>
    <div className={classNames(theme.Option, { [theme.InputError]: error })}>
      <label>
        <input className={theme.Input} type="radio" value="female" {...others} ref={ref} />
        Female
      </label>
    </div>
    <div className={classNames(theme.Option, { [theme.InputError]: error })}>
      <label>
        <input className={theme.Input} type="radio" value="male" {...others} ref={ref} />
        Male
      </label>
    </div>
    {error &&
      <span className={theme.ErrorText}>{error}</span>
    }
  </div>
));

GenderSelector.propTypes = {
  error: PropTypes.string,
};

export default GenderSelector;
